module.exports = __webpack_public_path__ + "media/G1.377b253d.mp3";